import 'whatwg-fetch';

import {FILE_UPLOAD_LOCATIONS} from './constants';

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
    return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
export function checkStatus(response) {
    if(response.status === 302) {
        window.location.href = '/expired';
    }
    //Checking specifically for 204 because the POST create returns a 204 if object exists.
        if (response.status !== 204 && response.status >= 200 && response.status < 300) {
            return response;
        }

    const error = new Error(response.statusText);
    error.response = response;
    error.status = response.status;
    throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export function request(url, options) {
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON);
}

export function requestConfig(method, body) {
    let config = {
        method: method,
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: new Headers({
            'Accept': 'application/json'
        })
    };

    if (method === 'POST' || method === 'PUT') {
        config.headers.append('Content-Type', 'application/json');
    }


    if (body !== null) {
        config.body = JSON.stringify(body);
    }

    return config;
}

export function generateFileUrl(file, email, location) {
    console.log(file);
    let splitName = file.clientFileName ? file.clientFileName.split('.') : file.name.split('.');
    let extension = splitName[splitName.length - 1];

    if (location === FILE_UPLOAD_LOCATIONS.THUMBNAIL) {
        extension = 'png'
    }
    return `${process.env.API_URL.replace('PinPoint', 'pinpoint')}${email}/${location}/asset-${file.id}.${extension}`;
}



// WEBPACK FOOTER //
// ./src/utils/request.js